import { Absent_getInstance1my5kmv368g0i as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePairAssignmentsInputClass;
function SavePairAssignmentsInput() {
  if (SavePairAssignmentsInputClass === VOID) {
    class $ {
      constructor(partyId, pairingSetId, date, pairs, discordMessageId, slackMessageId) {
        discordMessageId = discordMessageId === VOID ? Absent_getInstance() : discordMessageId;
        slackMessageId = slackMessageId === VOID ? Absent_getInstance() : slackMessageId;
        this.s6n_1 = partyId;
        this.t6n_1 = pairingSetId;
        this.u6n_1 = date;
        this.v6n_1 = pairs;
        this.w6n_1 = discordMessageId;
        this.x6n_1 = slackMessageId;
      }
      toString() {
        return 'SavePairAssignmentsInput(partyId=' + this.s6n_1.toString() + ', pairingSetId=' + this.t6n_1.toString() + ', date=' + this.u6n_1.toString() + ', pairs=' + toString(this.v6n_1) + ', discordMessageId=' + toString(this.w6n_1) + ', slackMessageId=' + toString(this.x6n_1) + ')';
      }
      hashCode() {
        var result = this.s6n_1.hashCode();
        result = imul(result, 31) + this.t6n_1.hashCode() | 0;
        result = imul(result, 31) + this.u6n_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.v6n_1) | 0;
        result = imul(result, 31) + hashCode(this.w6n_1) | 0;
        result = imul(result, 31) + hashCode(this.x6n_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePairAssignmentsInput()))
          return false;
        if (!this.s6n_1.equals(other.s6n_1))
          return false;
        if (!this.t6n_1.equals(other.t6n_1))
          return false;
        if (!this.u6n_1.equals(other.u6n_1))
          return false;
        if (!equals(this.v6n_1, other.v6n_1))
          return false;
        if (!equals(this.w6n_1, other.w6n_1))
          return false;
        if (!equals(this.x6n_1, other.x6n_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePairAssignmentsInput');
    SavePairAssignmentsInputClass = $;
  }
  return SavePairAssignmentsInputClass;
}
//region block: exports
export {
  SavePairAssignmentsInput as SavePairAssignmentsInput3tgrc8c2zd524,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsInput.mjs.map
